import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "example" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { id: "bar" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h1", null, "Vue Email Editor (Demo)", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EmailEditor = _resolveComponent("EmailEditor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.saveDesign && _ctx.saveDesign(...args)))
                }, "Save Design"),
                _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.exportHtml && _ctx.exportHtml(...args)))
                }, "Export HTML")
            ]),
            _createVNode(_component_EmailEditor, {
                ref: "emailEditor",
                onLoad: _ctx.editorLoaded,
                onReady: _ctx.editorReady,
                options: _ctx.options
            }, null, 8, ["onLoad", "onReady", "options"])
        ])
    ]));
}
